import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';
import { cn } from '@/utils/cn';

/**
 * PillTag — the rounded-pill tag used across the Labs screens.
 * fs-* native, Inter label-md (12/14, medium).
 *
 * Variants:
 *   - `brand` (default): fs-brand-subtle fill + fs-brand text — the "Module 1 of 4" / track pill.
 *   - `meta`: no fill, fs-text-subtle text — the plain meta pill (see also <MetaTag/> for the icon+label row item).
 *   - `outline`: subtle border, no fill, fs-text (primary) text + 14px leading icon — the M2-intro framing chips.
 *   - `warning`: amber fill (fs-warning-subtle) + amber text (fs-warning) — the M3-activity "Practice example" table tag.
 */
export function PillTag(t0) {
  const $ = _c(12);
  const {
    children,
    variant: t1,
    icon: Icon,
    className
  } = t0;
  const variant = t1 === undefined ? "brand" : t1;
  const t2 = variant === "brand" && "bg-fs-brand-subtle text-fs-brand";
  const t3 = variant === "meta" && "text-fs-text-subtle";
  const t4 = variant === "outline" && "border border-fs-border text-fs-text";
  const t5 = variant === "warning" && "bg-fs-warning-subtle text-fs-warning";
  let t6;
  if ($[0] !== className || $[1] !== t2 || $[2] !== t3 || $[3] !== t4 || $[4] !== t5) {
    t6 = cn("inline-flex items-center gap-fs-xxs rounded-fs-pill px-fs-sm py-fs-xxs font-medium text-[12px] leading-[14px]", t2, t3, t4, t5, className);
    $[0] = className;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== Icon) {
    t7 = Icon ? <Icon className="h-3.5 w-3.5" strokeWidth={1.75} /> : null;
    $[6] = Icon;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== children || $[9] !== t6 || $[10] !== t7) {
    t8 = <span className={t6}>{t7}{children}</span>;
    $[8] = children;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  return t8;
}